import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { getLast3Months } from "../../utils/getLast3Months";
import { ApiHook } from "../../hooks/apiHook";
import { ProgressBar } from "react-bootstrap";
import { getLast2Years } from "../../utils/getLast2years";
import Skeleton from "react-loading-skeleton";
import IncentivesSkeleton from "./IncentivesSkeleton";
import { months } from "../../utils/months";
import { useParams } from "react-router";

const EarnedIncntives = () => {
   const params = useParams();
  const [selectedMonth, setSelectedMonth] = useState(
    getLast3Months()?.[0].fullDate
  );
    const [userId, setUserId] = useState(params.id);
  const { t } = useTranslation();
  const data = ApiHook.CallEarnedIncentives(selectedMonth,userId);

  const handleMonthChange = (month) => setSelectedMonth(month);

  /**
   * Helper to render a progress bar with required values
   */
  const renderProgressBar = (item, index, levelIndex) => {
    if (!data?.data?.level?.[levelIndex]) return "N/A";

    const level = data.data.level[levelIndex];
    const required =
      index === 0
        ? level.monthThreeLess
        : index === 1
        ? level.monthTwo
        : index === 2
        ? level.monthOne
        : null;

    if (!required) return "N/A";

    return (
      <>

      <ProgressBar
          variant="success"
          now={item.totalPv ?? 0}
          max={required}
          label={`${item.totalPv ?? 0} / ${required}`}
        />
        <span className="required-text">
          {required} {t("required") || "Required"}
        </span>
     
      </>
    );
  };

  const generalRenderProgressBar = (required, current) => {
    if (required == null || isNaN(required)) return "N/A";

    const currentValue = parseFloat(current) || 0;
    const requiredValue = parseFloat(required) || 0;

    return (
      <>
        <ProgressBar
          variant="success"
          now={currentValue}
          max={requiredValue}
          label={`${currentValue} / ${requiredValue}`}
        />
        <span className="required-text">
          {requiredValue} {t("required") || "Required"}
        </span>
      </>
    );
  };
  const renderIcons = (renderCondition) => {
    if (renderCondition == null) return null;

    return renderCondition ? (
      <i
        className="fa fa-check-circle"
        style={{
          color: "green",
          fontSize: "15px",
          position: "relative",
          top: "1px",
        }}
      />
    ) : (
      <i
        className="fa fa-times-circle"
        style={{
          color: "red",
          fontSize: "15px",
          position: "relative",
          top: "1px",
        }}
      />
    );
  };

  const countIndicator = (required, current) => {
    if (required == null || current == null) return "N/A";

    return (
      <>
        <div
          style={{
            display: "flex",
            gap: "30px",
            justifyContent: "flex-start",
          }}
        >
          {/* Row of boxes */}
          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {[...Array(required)].map((_, idx) => (
              <div
                key={idx}
                style={{
                  height: "20px",
                  width: "20px",
                  border: "1px solid green",
                  backgroundColor: current > idx ? "green" : "transparent",
                }}
              />
            ))}
          </div>

          <span
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              alignContent: "center",
            }}
          >
            {required}
          </span>
        </div>
      </>
    );
  };

  const isUserQualified = () => {
    if (!data?.data) return false;

    const { months, summary, config } = data.data;

    // Check all qualification criteria
    const isActiveEveryMonth = months?.every((obj) => obj.activeStatus);
    const hasEnoughTotalPv = summary?.totalPv >= config?.total_cc;
    const hasEnoughNewPv = summary?.totalNewCC >= config?.new_cc;
    const hasEnoughSupervisors =
      summary?.superVisors >= config?.supervisor_lines;

    // User is qualified only if ALL conditions are met
    return (
      isActiveEveryMonth &&
      hasEnoughTotalPv &&
      hasEnoughNewPv &&
      hasEnoughSupervisors
    );
  };
  if (data.isLoading) {
    return <IncentivesSkeleton />;
  }
  const qualified = isUserQualified();

  return (
    <div className="ewallet_top_btn_sec">
      <div className="row justify-content-between">
        <div className="col-md-4"></div>
        <div className="col-md-4 text-end "></div>
      </div>
      <div className="ewallet_table_section">
        <div className="ewallet_table_section_cnt">
          <div className="table-responsive min-hieght-table">
            <h6 className="table-heading-incentives">{t("earned_incentive")}</h6>
            <div className="row incentives-subheading justify-content-between">
                <span>({t("Name")} : {data?.data?.fullName}</span>
                <span>{t("User Name")} : {data?.data?.username}</span>
              <span>
                {t("Qualification Level")} :{" "}
                {data?.data?.earnedIncentiveLevel
                  ? `Level ${data.data.earnedIncentiveLevel}`
                  : "N/A"}
              </span>
            </div>
            <div className="table-container">
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td>
                      <h5>{t("4kcActive")}</h5>
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#333",
                          marginTop: "10px",
                        }}
                      >
                        {t("Required")}: {t("Current month")}{" "}
                        {renderIcons(
                          Number(
                            data?.data?.currentMonthUserVolume?.activeStatus
                          ),
                          1
                        )}
                      </p>
                    </td>
                    <td colSpan={10}>
                      {data?.data?.currentMonthUserVolume?.activeStatus
                        ? "YES"
                        : "NO"}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h5>{t("ativeManagers")}</h5>
                      {t("Required")}:{t("Current month")}{" "}
                      {renderIcons(
                        Number(
                          data?.data?.currentMonthUserVolume
                            ?.downlineLeaderCount
                        ) >= 1
                      )}
                    </td>
                    <td colSpan={10}>
                      {/* <span className="stat-value"> */}
                      {data?.data?.currentMonthUserVolume
                        ?.downlineLeaderCount ?? 0}
                      {/* </span> */}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h5>{t("totalPv")}</h5>
                      {t("Required")}:{Number(
                        data?.data?.level[0].monthThreeLess
                      )}{" "}
                      {renderIcons(
                        Number(data?.data?.currentMonthUserVolume?.totalPv) >=
                          Number(data?.data?.level[0].monthThreeLess)
                      )}
                    </td>
                    <td colSpan={10}>
                      {generalRenderProgressBar(
                        Number(data?.data?.level[0].monthThreeLess),
                        data?.data?.currentMonthUserVolume?.totalPv
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h5>{t("QualificationStart")}</h5>
                    </td>
                    <td colSpan={10}>
                      {/* <span className="stat-value"> */}
                      {data?.data?.qulificationDates?.startDate ?? "N/A"}
                      {/* </span> */}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h5>{t("QulifcationEnd")}</h5>
                    </td>
                    <td colSpan={6}>
                      {data?.data?.qulificationDates?.endDate ?? "N/A"}
                    </td>
                  </tr>
        

                  <tr>
                    <th colSpan={2}>Month</th>
                    <th colSpan={2}>{t("ativeManagers")}</th>
                    <th colSpan={2}>{t("totalPv")}</th>
                    <th colSpan={2}>{t("Level 1")}</th>
                    <th colSpan={2}>{t("Level 2")}</th>
                    <th colSpan={2}>{t("Level 3")}</th>
                  </tr>

                  {data?.data?.userPoints?.map((item, index) => (
                    <tr key={index}>
                      <td colSpan={2}>{item.monthName}</td>
                      <td colSpan={2}>{item.downlineLeaderCount ?? 0}</td>
                      <td colSpan={2}>{item.totalPv ?? "N/A"}</td>
                      <td colSpan={2}>{renderProgressBar(item, index, 0)}</td>
                      <td colSpan={2}>{renderProgressBar(item, index, 1)}</td>
                      <td colSpan={2}>{renderProgressBar(item, index, 2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* ===== Month Tabs ===== */}
              <div className="month-tabs">
                {getLast3Months().map((month) => (
                  <button
                    key={month.fullDate}
                    className={`month-tab ${
                      selectedMonth === month.fullDate ? "active" : ""
                    }`}
                    onClick={() => handleMonthChange(month.fullDate)}
                  >
                    {month.value}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EarnedIncntives;
